import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMyTurnosPaciente, useTurnoDelPaciente } from '../data/hooks/useTurnos.hook'
import { ButtonInApp } from './ButtonInApp.component'
import { ContainerApp, HeaderApp, ContentApp, FooterApp } from './Layout.app'
import { Spinner } from '../components/spinner/Spinner.component'
import { api } from '../data/api'
import { useState } from 'react'

export const CancelarTurnoApp = () => {

	const [searchParams] = useSearchParams()
	const turnoIdParam = searchParams.get('turnoId')
	const turnoId = turnoIdParam ? Number(turnoIdParam) : undefined
	const { data: turno, isLoading, error } = useTurnoDelPaciente(turnoId)
	const { invalidateMyTurnosPaciente } = useMyTurnosPaciente()
	const navigate = useNavigate()
	const [cancelado, setCancelado] = useState(false)
	const [saving, setSaving] = useState(false)

	const handleBack = () => {
		navigate(cancelado ? '/app/menu' : '/app/turnos-pendientes')
	}

	const handleConfirmar = async () => {
		setSaving(true)
		if (!turno) return
		try {
			await api.post(`/api/turnos/cancelarTurno/${turno.id}/P`)
			setCancelado(true)
			await invalidateMyTurnosPaciente()
		} catch (error) {
			console.error("### error", error)
		} finally {
			setSaving(false)
		}
	}

	if (isLoading || saving) return <Spinner />

	return (
		<ContainerApp>
			<HeaderApp title={cancelado ? 'Turno Cancelado' : 'Cancelar Turno'} />
			<ContentApp>
				{!cancelado && (
					<>
						<p style={{ fontWeight: 'bold' }}>¿Está seguro de querer cancelar el turno?</p>
						<p>
							{turno?.medicoNombre} <br />
							{turno?.especialidadNombre} <br />
							{turno?.fecha} <br />
							{turno?.hora}
						</p>
						<p style={{ fontStyle: 'italic' }}>
							(El turno será cancelado y deberá usar la opción de Pedir Ayuda para gestionar el Reembolso. Pueden haber cargos de parte de Mercado Pago por el reembolso.)
						</p>
					</>
				)}
				{cancelado && (
					<p style={{ fontWeight: 'bold' }}>
						El Turno ha sido cancelado correctamente. Por favor, utiliza la opción de Pedir Ayuda en el menú principal para gestionar el Reembolso. .
					</p>
				)}
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					onClick={handleBack}
					type="button" 
				/>
				{!cancelado && <ButtonInApp 
					label="Confirmar"
					onClick={handleConfirmar}
					type="button" 
				/>}
			</FooterApp>
		</ContainerApp>
	)
}